import { Link } from "react-router-dom";

const ITEMS = [
  ["Evaluación psicopedagógica", "Proceso diagnóstico completo que incluye entrevistas iniciales, administración de técnicas específicas, análisis de producciones y devolución profesional con informe escrito."],
  ["Intervención psicopedagógica", "Tratamiento sostenido en el tiempo orientado a fortalecer los procesos de aprendizaje, la organización cognitiva y la relación del paciente con el saber."],
  ["Acompañamiento educativo", "Trabajo articulado con la trayectoria escolar: estrategias de estudio, organización, hábitos y sostén en momentos de transición."],
  ["Orientación a familias", "Espacios de escucha y asesoramiento para que el entorno familiar pueda acompañar el proceso con herramientas concretas."],
  ["Orientación a instituciones", "Asesoramiento a escuelas y equipos docentes en configuraciones de apoyo, adecuaciones y abordajes situados."],
  ["Psicopedagogía clínica", "Abordaje clínico del aprender, atendiendo a la singularidad subjetiva y a la dimensión vincular del proceso."],
  ["Psicopedagogía forense", "Evaluaciones e informes psicopedagógicos en contextos judiciales, con encuadre técnico y ético riguroso."],
];

export default function Servicios() {
  return (
    <div data-testid="servicios-page" className="mx-auto max-w-7xl px-6 py-24">
      <p className="label-xs">Servicios</p>
      <h1 className="mt-4 max-w-3xl text-5xl tracking-tight sm:text-6xl">Áreas de trabajo</h1>
      <div className="mt-14 divide-y divide-[#dcd5ce] border-y border-[#dcd5ce]">
        {ITEMS.map(([t, d], i) => (
          <div key={t} data-testid={`servicio-item-${i}`} className="grid gap-6 py-10 md:grid-cols-[0.9fr_1.4fr]">
            <div className="flex items-start gap-5">
              <span className="label-xs pt-2">{String(i + 1).padStart(2, "0")}</span>
              <h2 className="text-3xl leading-snug">{t}</h2>
            </div>
            <p className="leading-relaxed text-[#4a4744]">{d}</p>
          </div>
        ))}
      </div>
      <Link to="/contacto" data-testid="servicios-cta" className="mt-14 inline-block btn-gold rounded-full px-10 py-4 text-xs font-semibold uppercase tracking-[0.18em]">
        Solicitar un turno
      </Link>
    </div>
  );
}
